module.exports = __webpack_public_path__ + "static/media/history-icon.ab81c9af.svg";